import { defineMessages } from 'react-intl';

export default defineMessages({
  login: 'Login',
  email: 'E-mail',
  emailRequired: 'E-mail required!',
  password: 'Password',
  passwordRequired: 'Password required!',
  mfa: 'Please enter the code you received by SMS.',
  mfaCode: 'Verification Code',
  mfaCodeRequired: 'Code required!',
  forgotPassword: 'Did you forget your password?',
  loginFailed: 'Login failed. Try again later or check the console for more info.',
  signUp: 'Dont have an account? Sign up here.',
  invalid_grant: 'Invalid email or password.',
  too_many_attempts: 'You have too many failed login attempts. Please contact us.',
  invalid_phone_number: 'Your phone number for verification is invalid. Please contact us.',
  invalid_mfa_code: 'Invalid verification code.',
});
